export const COUNTERPARTY_COMMENT_VERDICTS = Object.freeze([
  'accept',
  'reject',
  'revise',
  'adjust_deal_term',
]);

const OWNER_SIDES = new Set(['owner_landlord', 'owner_tenant']);
const VERDICTS = new Set(COUNTERPARTY_COMMENT_VERDICTS);

// `revisedText` is the payload of a `revise` verdict, not an independent
// reading, so it lives and dies with the verdict that justifies it. The gate
// runs before validation (lease_editor_controller.js:398), so dropping the
// verdict alone would leave replacement prose on the review, attached to the
// diff item, with nothing left to say it was ever grounded in a playbook.
function withoutUngroundedRecommendation(review, verdict) {
  const gated = { ...review };
  if (!verdict) delete gated.verdict;
  if (verdict !== 'revise') delete gated.revisedText;
  return gated;
}

/**
 * Apply design section 7's recommendation gate independently to each change.
 * The model's verdict is advisory input, not proof that the customer supplied
 * the policy needed to make it. A verdict survives only when the owner side is
 * declared and this change's classified concept has a playbook entry, and its
 * `revisedText` survives only alongside a surviving `revise`.
 */
export function gateCounterpartyCommentVerdicts(
  reviews,
  { ownerSide, playbookConcepts } = {},
) {
  if (!Array.isArray(reviews)) return reviews;

  const hasDeclaredOwnerSide = OWNER_SIDES.has(ownerSide);
  const coveredConcepts = new Set(
    Array.isArray(playbookConcepts) ? playbookConcepts : [],
  );

  return reviews.map(review => {
    if (!review || typeof review !== 'object' || Array.isArray(review)) {
      return review;
    }

    if (
      !hasDeclaredOwnerSide ||
      !coveredConcepts.has(review.concept) ||
      !VERDICTS.has(review.verdict)
    ) {
      return withoutUngroundedRecommendation(review, null);
    }

    return withoutUngroundedRecommendation(review, review.verdict);
  });
}
